import noticeError from "src/app/utilities/noticeError";
import { addPageAction } from "./newrelic";

export const isWebView = () => {
  if (typeof window === "undefined") {
    return false;
  }

  const params = new URLSearchParams(window.location.search);
  const appPlatform = params.get("app_platform");
  const appPlatforms = ["ios", "android"];

  if (appPlatforms.includes(appPlatform)) {
    localStorage.setItem("app_platform", appPlatform);
  }

  return (
    appPlatforms.includes(appPlatform) ||
    Boolean(localStorage.getItem("app_platform"))
  );
};

export const trackClickByPlatform = (href) => {
  if (typeof window === "undefined") return;

  const platform = window.localStorage.getItem("app_platform");

  if (platform) {
    addPageAction(`sierra_${platform}_chat_deeplink_clicked`, { href });
  } else {
    noticeError(
      new Error(
        "Sierra chat deeplink clicked but no app_platform found in localStorage"
      )
    );
  }
};
